import { Link } from "react-router-dom";
import { ACCOUNT_BOOK_ORDER_MENU_ACTION } from "@icoach/accountBook/utils/orderMenuItems";
import { isFunction } from "@util/utils";

/**
 * 將 getOrderMenuItems 的純設定轉成 OverflowMenu 的 menuData（含 Link／onClick）
 *
 * @param {Array<{ type: string, text: string, href?: string, action?: string }>} menuItems
 * @param {{ refresh?: Function, dialogRef?: import("react").RefObject }} ctx
 * @param {object} rowData 供 action：orderID、orderReturnID、certificatePath、confirmPath 等
 */
export const mapOrderMenuData = (menuItems, { refresh, dialogRef }, rowData) => {
	const { orderID, orderReturnID, certificatePath, confirmPath } = rowData || {};

	// 需重刷列表的 action 將 refresh 傳入 open*Dialog（…, refresh）；僅開 PDF 預覽的不帶 refresh
	const actionRunners = {
		[ACCOUNT_BOOK_ORDER_MENU_ACTION.ALLOWANCE]: () => isFunction(dialogRef?.current?.openOrderAllowanceDialog) && dialogRef.current.openOrderAllowanceDialog({ orderID }, refresh),
		[ACCOUNT_BOOK_ORDER_MENU_ACTION.VOID_INVOICE]: () => isFunction(dialogRef?.current?.openOrderInvoiceVoidDialog) && dialogRef.current.openOrderInvoiceVoidDialog({ orderID }, refresh),
		[ACCOUNT_BOOK_ORDER_MENU_ACTION.REISSUE_INVOICE]: () => isFunction(dialogRef?.current?.openResetOrderInvoiceDialog) && dialogRef.current.openResetOrderInvoiceDialog({ orderID }, refresh),
		[ACCOUNT_BOOK_ORDER_MENU_ACTION.DELETE_ORDER]: () => isFunction(dialogRef?.current?.openDeleteOrderDialog) && dialogRef.current.openDeleteOrderDialog({ orderID }, refresh),
		[ACCOUNT_BOOK_ORDER_MENU_ACTION.RESTORE_ORDER]: () => isFunction(dialogRef?.current?.openReinitOrderDialog) && dialogRef.current.openReinitOrderDialog({ orderID }, refresh),
		[ACCOUNT_BOOK_ORDER_MENU_ACTION.DOWNLOAD_ALLOWANCE_CERTIFICATE]: () =>
			isFunction(dialogRef?.current?.openTriplicateAllowanceCertificatePdfDialog) &&
			dialogRef.current.openTriplicateAllowanceCertificatePdfDialog({ orderID, orderReturnID, certificatePath }),
		[ACCOUNT_BOOK_ORDER_MENU_ACTION.UPLOAD_ALLOWANCE_CERTIFICATE]: () =>
			isFunction(dialogRef?.current?.openUploadTriplicateAllowanceCertificateDialog) && dialogRef.current.openUploadTriplicateAllowanceCertificateDialog({ orderID, orderReturnID }, refresh),
		[ACCOUNT_BOOK_ORDER_MENU_ACTION.PREVIEW_UPLOADED_ALLOWANCE_CERTIFICATE]: () =>
			isFunction(dialogRef?.current?.openTriplicateAllowanceConfirmPdfDialog) && dialogRef.current.openTriplicateAllowanceConfirmPdfDialog({ confirmPath }),
	};

	return menuItems.map(entry => {
		if (entry.type === "link") {
			return {
				text: entry.text,
				component: Link,
				to: entry.href,
			};
		}
		const run = actionRunners[entry.action];
		return {
			text: entry.text,
			onClick: () => run?.(),
		};
	});
};
